import EstimatedDateSetup from '@/components/EstimatedDateSetup';
import { PrefixIconColor, PrefixIcon as PrefixIconEnum, PrefixIconSize, TextAppearance, TextSize } from '@/constants/enum';
import { IStateCheckoutRule } from '@/pages/Checkout/components/CreateUpdate';
import { CreateUpdateStyled } from '@/pages/Checkout/components/CreateUpdate/styled';
import MessageText from '@/pages/Checkout/components/MessageText';
import RuleName from '@/pages/Checkout/components/RuleName';
import SelectShippingMethod from '@/pages/Checkout/components/SelectShippingMethod';
import checkoutRuleSlice, { checkoutRuleSettingsSelector } from '@/redux/slice/checkoutRule.slice';
import { IOptions } from '@/types';
import { useDispatch, useSelector } from 'react-redux';

export default function Step1() {
  const dispatch = useDispatch();

  const state = useSelector(checkoutRuleSettingsSelector);

  const handleUpdateState =
    (key: keyof IStateCheckoutRule) =>
    (value: string | IOptions[] | PrefixIconEnum | TextSize | TextAppearance | PrefixIconSize | PrefixIconColor) => {
      dispatch(checkoutRuleSlice.actions.handleChange({ key, value }));
    };

  return (
    <CreateUpdateStyled>
      <RuleName value={state.name} onChange={handleUpdateState('name')} />

      <div className="mt-12">
        <SelectShippingMethod
          isRequired
          selectedOptions={state.shippingMethods}
          setSelectedOptions={handleUpdateState('shippingMethods')}
          defaultOptions={state?.shippingMethods || []}
        />
      </div>

      <div className="mt-12">
        <MessageText isRequired inputValue={state.messageText} setInputValue={handleUpdateState('messageText')} />
      </div>

      <div className="mt-4">
        <EstimatedDateSetup
          required
          orderToShipDays={state.minPreparationDays.toString()}
          onChangeOrderToShipDays={(newValue) => {
            handleUpdateState('minPreparationDays')(newValue);
          }}
          prepDays={state.maxPreparationDays.toString()}
          onChangePrepDays={(newValue) => {
            handleUpdateState('maxPreparationDays')(newValue);
          }}
          shipToReceiveDays={state.minDeliveryDays.toString()}
          onChangeShipToReceiveDays={(newValue) => {
            handleUpdateState('minDeliveryDays')(newValue);
          }}
          estDays={state.maxDeliveryDays.toString()}
          onChangeEstDays={(newValue) => {
            handleUpdateState('maxDeliveryDays')(newValue);
          }}
        />
      </div>
    </CreateUpdateStyled>
  );
}
